import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const altiumPrimaryScale = Object.freeze({
    50: '#EEF5FD',
    100: '#D6E6FB',
    200: '#A3D4F2',
    300: '#7E9CF6',
    400: '#426DFF',
    500: '#0043FF',
    600: '#0040D6',
    700: '#053A9E',
    800: '#0A3170',
    900: '#0C2749',
    950: '#000E35',
});

export default definePreset(Aura, {
    semantic: {
        primary: { ...altiumPrimaryScale },
    },
});
